<template>
  <div class="background">
    <footer class="page-footer font-small text-light">
      <div class="container">
        <div class="row">
          <div class="row max auto">
            <div class="my-auto col">
                <a class="heapbtn" target="_blank" aria-label="shuffle monster SHUF" href="https://shuffle.monster/">Join the heap</a>
                  <h2>The last address has {{ top_pos }} SHUF</h2>
            </div> 
          </div>
          <div class="row mobile-top-margin max auto order-1">
            <div class="my-auto col mobile-top-margin">
              <!-- Grid column -->
               <div class="col-md-12">
                  <div>
                    <a target="_blank" aria-label="Telegram chat group" href="https://t.me/shuftoken" class="icon fa fa-telegram"></a>
                    <a target="_blank" aria-label="Medium" href="https://medium.com/@ShuffleMonster" class="icon fa fa-medium"></a>
                    <a target="_blank" aria-label="Twitter" href="https://twitter.com/ShuffleToken" class="icon fa fa-twitter"></a>
                  </div>
                </div>
                <div class="footer-copyright text-center py-3">2019 - GPL v3.0<br/>
                  Icons by <a target="_blank" aria-label="icons8" href="https://icons8.com/">icons8</a><br/>
                  Learn more about the <a target="_blank" aria-label="Site home" href="https://shuffle.monster/">shuffle.monster</a>  
                </div>
                  <!-- Grid column -->
            </div>
          </div>
          <div class="row mobile-top-margin max auto">
            <div class="col my-auto mobile-top-margin flex-center">
              <button v-on:click="open_uniswap" class="action-button join-button auto btn btn-uniswap">Trade on Uniswap</button>
              <br/><br/>
              <button v-on:click="open_defswap" class="action-button join-button auto btn btn-defswap">Trade on Defswap</button>
              <br/><br/>
              <button v-on:click="open_ddex" class="action-button join-button auto btn btn-ddex">Trade on DDEX</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer -->
  </div>
</template>
<script>
import { readWeb32, getTokenContract} from '../web3.js';
export default {
  name: 'Footer',
  data: function(){
      return {
          top_pos: this.top_pos
        };
  },
  created: async function() {
        this.top_pos = "...";
        const token = getTokenContract(readWeb32());
        const result = await token.methods.heapTop().call();
        this.top_pos = (result[1] / 10 ** 18).toFixed(0);
  },
  methods: {
    open_uniswap: function() {
        var redirectWindow = window.open(`https://uniswap.exchange/swap/0x3a9fff453d50d4ac52a6890647b823379ba36b9e`, '_blank');
        redirectWindow.location;
    },
    open_defswap: function() {
        var redirectWindow = window.open(`https://defswap.io/swap/0x3a9fff453d50d4ac52a6890647b823379ba36b9e`, '_blank');
        redirectWindow.location;
    },
    open_ddex: function() {
        var redirectWindow = window.open(`https://legacy.ddex.io/trade/SHUF-WETH`, '_blank');
        redirectWindow.location;
    }
  }
}
</script>
<style scoped>
.max{
  max-width:365px;
  min-width: 32%;
}
.icon{
  font-size: 33px;
  color: black;
  background-color: white;
  padding: 16px;
  margin: 16px;
}
.icon:hover {
  padding: 18px;
  margin: 14px;
  text-decoration: none;
}
.background {
  position: static;
  width: 100%;
  padding: 60px;
  background: linear-gradient(181.07deg, #21540F 9.11%, #153413 83.74%), #153312;
}
.btn-uniswap{
  background-color: #B55ADD;
  border-color: #ac45d9;
}
.btn-ddex{
  background-color: #2669CE;
  border-color: #123F93;
}
.btn-defswap{
  background-color:rgb(250, 128, 114);
  border-color: rgb(250, 128, 114);
}
.btn {
  color: #fff;
  width: 250px; 
  text-align: center;
  display: inline-block;
}
.btn:hover {
  color: white;
  font-weight: 900;
}
.flex-center{
  padding:0 !important;
}
.heapbtn{
  position: static;
  font-weight: 800;
  font-size: 50px;
  text-align: left;
  line-height: 93.19%;
  display: flex;
  letter-spacing: -0.01em;
  color: #FFFFFF;
  margin-bottom: 10px;
  text-shadow: 4px 4px 6px #000000;
}
h2{
  text-shadow: 3px 3px 6px #000000;   
}
.auto{
  margin-left: auto;
  margin-right: auto;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.join-button {
  position: relative;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-weight: 500;
  font-size: 19px;
  line-height: 93.19%;
  padding: 10px;
}
h1,h2{
  position: static;
  text-align: left;
  line-height: 93.19%;
  display: flex;
  letter-spacing: -0.02em;
  color: #FFFFFF;
}
h2{
  font-weight: 500;
  font-size: 30px;
}
h1{
  font-weight: 800;
  font-size: 50px;
}
@media screen and (max-width: 1200px) {
  .mobile-top-margin {margin-top:30px;}
}
@media screen and (max-width: 370px) {
  .background{padding-left:40px !important;padding-right:40px !important;}
}
</style>
